import { Link } from 'react-router-dom'
import { TermsContent } from './TermsContent'

export default function TermsPage() {
  return (
    <div className="legal-doc min-h-screen bg-white py-10">
      <div className="max-w-3xl mx-auto px-6">

        {/* Header */}
        <div className="mb-8 pb-6 border-b-2 border-brand-text">
          <p className="text-xs uppercase tracking-widest text-brand-text-muted mb-2">
            RegenerAI — Documento Legal
          </p>
          <h1 className="text-3xl font-bold text-brand-text mb-2">
            Termos de Uso
          </h1>
          <p className="text-sm text-brand-text-secondary">
            Versão 1.0 — Última atualização: 23 de março de 2026
          </p>
        </div>

        {/* Preamble */}
        <p className="text-sm text-brand-text-secondary mb-8 leading-relaxed border-l-4 border-brand-border pl-4">
          Este documento estabelece os termos e condições de uso da plataforma RegenerAI.
          Ao criar uma conta ou utilizar qualquer serviço, você confirma ter lido e aceitado
          integralmente o disposto abaixo.
        </p>

        {/* Content */}
        <TermsContent />

        {/* Footer */}
        <div className="mt-12 pt-6 border-t border-brand-border">
          <p className="text-xs text-brand-text-muted mb-6 leading-relaxed">
            Este documento foi elaborado com base na legislação brasileira vigente, em especial a
            Lei nº 10.406/2002 (Código Civil), a Lei nº 8.078/1990 (Código de Defesa do
            Consumidor) e a Lei nº 12.965/2014 (Marco Civil da Internet).
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/privacy" className="btn-secondary text-center">
              Política de Privacidade
            </Link>
            <Link to="/register" className="btn-primary text-center">
              Voltar para Cadastro
            </Link>
          </div>
        </div>

      </div>
    </div>
  )
}
